module.exports = __webpack_public_path__ + "static/img/cePath6.b3ccd5ba.gif";